module.exports = __webpack_public_path__ + "img/tips.531bc36a.png";